import { useEffect } from 'react';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import ServicesSection from './components/ServicesSection';
import BenefitsSection from './components/BenefitsSection';
import LocationSection from './components/LocationSection';
import BookingSection from './components/BookingSection';
import Footer from '../../components/feature/Footer';

export default function Home() {
  useEffect(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://masszazs17.hu';

    const existingScripts = document.querySelectorAll('script[data-schema="home"]');
    existingScripts.forEach((s) => s.remove());

    const localBusiness = {
      '@context': 'https://schema.org',
      '@type': 'LocalBusiness',
      name: 'Masszázs17',
      description:
        'Barátságos svédmasszázs szolgáltatás relaxációhoz és fájdalomcsökkentéshez Budapest XVII. kerületében.',
      url: siteUrl,
      telephone: '+36-XX-XXX-XXXX',
      priceRange: '5000-15000 HUF',
      image: `${siteUrl}/og-image.jpg`,
      address: {
        '@type': 'PostalAddress',
        streetAddress: 'Budapest XVII. kerület',
        addressLocality: 'Budapest',
        postalCode: '1173',
        addressCountry: 'HU',
      },
      geo: {
        '@type': 'GeoCoordinates',
        latitude: 47.4979,
        longitude: 19.2564,
      },
      openingHoursSpecification: [
        {
          '@type': 'OpeningHoursSpecification',
          dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
          opens: '09:00',
          closes: '18:00',
        },
      ],
      hasOfferCatalog: {
        '@type': 'OfferCatalog',
        name: 'Masszázs szolgáltatások',
        itemListElement: [
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'Svédmasszázs 30 perc',
            },
            price: '5000',
            priceCurrency: 'HUF',
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'Svédmasszázs 60 perc',
            },
            price: '10000',
            priceCurrency: 'HUF',
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'Svédmasszázs 90 perc',
            },
            price: '15000',
            priceCurrency: 'HUF',
          },
        ],
      },
      sameAs: [],
    };

    const webPage = {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: 'Masszázs17 – Budapest XVII. kerület relax és fájdalomcsökkentő masszázs',
      description:
        'Barátságos svédmasszázs a XVII. kerületben. Relaxáció és fájdalomcsökkentés, közvetlen emberi hozzáállással.',
      url: siteUrl,
      inLanguage: 'hu',
      isPartOf: {
        '@type': 'WebSite',
        name: 'Masszázs17',
        url: siteUrl,
      },
    };

    const person = {
      '@context': 'https://schema.org',
      '@type': 'Person',
      name: 'Grendorf Zoltán',
      jobTitle: 'Svédmasszőr',
      worksFor: {
        '@type': 'LocalBusiness',
        name: 'Masszázs17',
      },
      address: {
        '@type': 'PostalAddress',
        addressLocality: 'Budapest',
        postalCode: '1173',
        addressCountry: 'HU',
      },
    };

    [localBusiness, webPage, person].forEach((schema) => {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.setAttribute('data-schema', 'home');
      script.textContent = JSON.stringify(schema);
      document.head.appendChild(script);
    });

    return () => {
      document.querySelectorAll('script[data-schema="home"]').forEach((s) => s.remove());
    };
  }, []);

  return (
    <div className="min-h-screen bg-stone-50">
      <HeroSection />
      <AboutSection />
      <ServicesSection />
      <BenefitsSection />
      <LocationSection />
      <BookingSection />
      <Footer />
    </div>
  );
}
